import ScrollHint from 'scroll-hint';
import 'scroll-hint/css/scroll-hint.css';

// コラム本文中の横幅がはみ出す表(テーブル)に「スクロールできます」のヒントを表示する
new ScrollHint( '.js-scroll-hint' );